import { lru } from 'tiny-lru';

let cache = lru();

export const getCache = () => {
  if (cache === undefined) {
    cache = lru();
  }
  return cache;
};
